export const initialCustomer = {
	customerHash: null,
	communications: [
		{
			typeId: 1,
			details: '',
		},
	],
};
